export default {
  path: "/app/sub-contract",
  redirect: "/app/sub-contract",
  component: () => import("../layout"),
  children: [
    {
      name: "myListSubContract",
      path: "/app/sub-contract",
      component: () => import("../SubContractList.vue"),
      meta: {
        appName: "myListSubContract",
      },
    },
    {
      name: "listSubContractCanEdit",
      path: "/app/sub-contract-can-edit",
      component: () => import("../sub-contract-can-edit.list.vue"),
      meta: {
        appName: "listSubContractCanEdit",
      },
    },
    {
      path: "/app/sub-contract/:idSubContract/edit",
      name: "editSubContract",
      component: () => import("../SubContractEdit.vue"),
    },
    {
      path: "/app/sub-contract/:idSubContract/view",
      name: "viewSubContract",
      component: () => import("../SubContractView.vue"),
    },
    {
      path: "/app/sub-contract/model",
      name: "subContractModel",
      component: () => import("../childApp/subContractModel"),
      meta: {
        appName: "subContractModel",
      },
    },
    {
      path: "/app/sub-contract/supplier",
      name: "subContractSupplier",
      component: () => import("../childApp/subContractSupplier"),
      meta: {
        appName: "subContractSupplier",
      },
    },
    {
      path: "/app/contract/sub-contract-equipment-code",
      name: "subContractEquipmentCode",
      component: () => import("../childApp/subContractEquipmentCode"),
      meta: {
        appName: "subContractEquipmentCode",
      },
    },
    {
      path: "/app/sub-contract/sub-contract-notification",
      name: "subContractNotification",
      component: () => import("../childApp/subContractNotification"),
      meta: {
        appName: "subContractNotification",
      },
    },

    // APPROVAL
    {
      name: "myApprovalWaitingSubContract",
      path: "/app/sub-contract/my-approval-waiting",
      component: () => import("../MyApprovalWaitingSubContract.vue"),
      meta: {
        appName: "myApprovalWaitingSubContract",
      },
    },
    {
      name: "myApprovalDoneSubContract",
      path: "/app/sub-contract/my-approval-done",
      component: () => import("../MyApprovalDoneSubContract.vue"),
      meta: {
        appName: "myApprovalDoneSubContract",
      },
    },
    // REPORT
    {
      name: "reportSubContractLog",
      path: "/app/sub-contract/report-contract-log",
      component: () => import("../childApp/subContractLogNewV1"),
      meta: {
        appName: "reportSubContractLog",
      },
    },
    {
      name: "reportSubContractLogNew",
      path: "/app/sub-contract/report-contract-log-new",
      component: () => import("../childApp/subContractLogNewV1"),
      meta: {
        appName: "reportSubContractLogNew",
      },
    },
  ],
};
